import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import html2canvas from 'html2canvas';
import QRCode from 'qrcodejs2';
import { Tab, Tabs, IndexBar, IndexAnchor } from 'vant';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
import 'vant/lib/index-bar/style';
import 'vant/lib/index-anchor/style';
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(ElementUI);
import axios from 'axios';
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: require('./assets/i18n/zh'),
    en: require('./assets/i18n/en'),
  },
  silentTranslationWarn: true,
});

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
